/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantWorkweekConfigurationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetMerchantWorkweekConfigurationResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getMerchantWorkweekConfiguration = (request: GetMerchantWorkweekConfigurationRequest, options?: CashRequestOptions) => post<GetMerchantWorkweekConfigurationRequest, GetMerchantWorkweekConfigurationResponse>("/proxy/services/squareup.timecards.TimeCalculationService/GetMerchantWorkweekConfiguration", request, {...options, rejectOnError: true })